import { Layout } from "antd";
import { Table, Row, Card } from "antd";
import { UserOutlined, BookOutlined } from "@ant-design/icons";
import { useParams, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { getUsersInGroup, getCourseNameDetails } from "../../../service/GroupService";
import UserHOC from "../../shared/HOC/UserHOC";
import usePagination from "../../../hooks/usePagination";

const { Content } = Layout;

const UserGroupHistory = ({ setLoading }) => {
  const location = useLocation();
  const { id } = useParams();
  const [userList, setUserList] = useState([]);
  const [courseList, setCourseList] = useState([]);

  const {
    currentPage,
    pageSize,
    total,
    setTotal,
    paginationConfig,
    handlePageChange,
  } = usePagination(0, 10, 0);

  async function getUsers(page = currentPage, size = pageSize) {
    setLoading(true);
    const result = await getUsersInGroup(id, page, size);

    if (result?.success) {
      const data = result.data;

      if (!data?.content) {
        console.error("Invalid response received:", data);
        setUserList([]);
      } else {
        const users = data.content.map((user, index) => ({
          id: user.userId,
          srno: index + 1,
          name: `${user.firstName} ${user.lastName}`,
        }));

        setUserList(users);
        setTotal(data.totalElements);
      }
    } else {
      console.error("Error fetching users in group:", result?.data);
      setUserList([]);
    }

    setLoading(false);
  }

  async function getCourses() {
    const result = await getCourseNameDetails(id);

    if (result?.success) {
      const courses = result.data.map((user, index) => ({
        id: user.courseId,
        srno: index + 1,
        name: user.courseName,
        progress: user.progress,
        enrols: user.enrols,
        status:
          user.progress > 95
            ? "Completed"
            : user.progress > 0
              ? "In progress"
              : "Not started",
      }));
      setCourseList(courses);
    } else {
      console.error("Error fetching courses:", result?.data);
      setCourseList([]);
    }
  }

  useEffect(() => {
    getUsers();
    getCourses();
  }, [id]);

  const Usercolumns = [
    { title: "Sr No.", dataIndex: "srno" },
    { title: "User Name", dataIndex: "name", key: "name" },
  ];

  const Coursecolumns = [
    { title: "Sr No.", dataIndex: "srno" },
    { title: "Course Name", dataIndex: "name", key: "name" },
  ];

  return (
    <div className="user-section" style={{ overflowY: "hidden" }}>
      <Content style={{ margin: "0 16px" }}>
        <Row>
          {/* Users Table */}
          <Card
            title={
              <span>
                <UserOutlined style={{ color: "#FF4D4F", marginRight: 16 }} />
                Members of the group
              </span>
            }
            bordered
            style={{ width: 500, marginRight: 10 }}
          >
            <Table
              dataSource={userList}
              columns={Usercolumns}
              rowKey={(record) => record.id}
              pagination={{
                ...paginationConfig, 
                showSizeChanger: true,
              }}
              onChange={(pagination) => {
                handlePageChange(pagination); 
                getUsers(pagination.current - 1, pagination.pageSize); 
              }}
              scroll={{ x: "100%", y: "100%" }}
              locale={{ emptyText: "No users found for this group." }}
            />
          </Card>

          {/* Courses Table - client side, no server pagination needed */}
          <Card
            title={
              <span>
                <BookOutlined style={{ color: "#FF4D4F", marginRight: 8 }} />
                Courses of the group
              </span>
            }
            bordered
            style={{ width: 600, margin: 5 }}
          >
            <Table
              dataSource={courseList}
              columns={Coursecolumns}
              rowKey={(record) => record.id}
              pagination={{ pageSize: 10, showSizeChanger: false }} 
              scroll={{ x: "100%", y: "100%" }}
              locale={{ emptyText: "No courses found for this group." }}
            />
          </Card>
        </Row>
      </Content>
    </div>
  );
};

export default UserHOC(UserGroupHistory);